import AboutMe from "./compenent/AboutMe";
import Describe from "./compenent/Describe.js";
import NavBar from "./compenent/Navbar.js";
import IconBox from "./compenent/IconBox";
import Service from "./compenent/Service";
import Progress from "./compenent/Progress";
import Review from "./compenent/Review";
import Portfolio from "./compenent/Portfolio";
import Resume from "./compenent/Resume";
import Footer from "./compenent/Footer";
import Technologies from "./compenent/Technologies";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <>
      <NavBar />
      <Describe />
      <AboutMe />
      <Technologies />
      <Service />
      <IconBox />
      <Progress />
      <Resume />
      <Portfolio />
      <Review />
      <Footer />
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </>
  );
}

export default App;
